import { render, staticRenderFns } from "./tech-talk-detail.vue?vue&type=template&id=0040c394&"
import script from "./tech-talk-detail.vue?vue&type=script&lang=js&"
export * from "./tech-talk-detail.vue?vue&type=script&lang=js&"
import style0 from "./tech-talk-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports